<div class="container-fluid">
  <div class="row">
    <div class="col-12 d-flex justify-content-center align-items-center " *ngIf="!forgotPasswordCart"style="height: 80vh;"
     >
      <div class="row">
        <div class="col-12 main  border" style="margin-top: 10rem;">
          <div class="d-flex justify-content-center align-items-center">
            <img src="/assets/loginIcon/LogLogo.svg">
          </div>

          <h2 class="text-center"> <strong> Sign In To Your Account.</strong> </h2>
          <form #loginForm="ngForm" >
            <div class="mb-3">

              <label for="exampleInputEmail1" class="form-label" style="color: #454545; font-weight: 700;">Email
                address</label>
              <div class="input-wrapper">
                <img class="mailimg" id="mailimgs" src="/assets/loginIcon/mail.png">
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                  placeholder="Enter Your Mail" name="email" #email="ngModel" [(ngModel)]="loginrequest.email">

              </div>
              <div style="color: red;" *ngIf="email.invalid && email.touched">
                Invalid email
              </div>
            </div>
            <div class="mb-3">

              <label for="exampleInputPassword1" class="form-label"
                style="color: #454545; font-weight: 700;">Password</label>
              <div class="input-wrapper">
                <img class="icon-start" src="/assets/loginIcon/pass.png">
                <input [type]="singINPasswordFieldType" class="form-control" id="exampleInputPassword1" name="password"
                  (ngModelChange)="nuable()" [(ngModel)]="loginrequest.password" placeholder="Password">
                <p> <img *ngIf="singINPasswordFieldType === 'password'" src="/assets/loginIcon/showpass.png"
                    alt="Show Password" class="eye-icon" (click)="toggleSignINPassword()" />
                  <img *ngIf="singINPasswordFieldType === 'text'" src="/assets/loginIcon/Frame.png" alt="Hide Password"
                    class="eye-icon" (click)="toggleSignINPassword()" />
                </p>
              </div>
              <p style="color:red"> {{this.error}}</p>

            </div>
            <div class="mb-3 form-check d-flex justify-content-between ">
              <div>
                <input type="checkbox" class="form-check-input" id="exampleCheck1"  [(ngModel)]="rememberMe" (ngModelChange)="onRememberChange($event)"    name="rememberMe" >
                <label class="form-check-label" for="exampleCheck1" style="color: #454545; font-weight: 700;"
                 >Remember
                  For 30 Days</label>
              </div>
              <p class="cursor" style="color: #309EAE; font-weight: 700;" (click)="toggleForgotPasswordCart()"> Forgot
                Password</p>
            </div>
            <button type="submit" class="submitbtn" style="width: 100%;" (click)="loginAuth()"> <strong > Sign
                In</strong> </button>
          </form>


        </div>
      </div>
    </div>



    <div class="col-12 d-flex justify-content-center align-items-center" *ngIf="forgotPasswordCart" style="height: 100vh;">
      <div class="forgot-password-card" >
        <div class="WhiteInnerDiv">
          <div class="wlcmDiv">
            <h3 class="wlcmHead">Reset Your Password</h3>
            <p class="smHead">Reset your password and get back to your account.</p>
          </div>

          <div class="formDiv user-login">
            <div *ngIf="!setForgotNewPasswordCart">


              <div *ngIf="forgotPasswordIsMailThrough">

                <form #forgotPasswordForm="ngForm" (ngSubmit)="onSubmitForgotPassword()">
                  <div class="form-group mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <label class="labels">Email address</label>
                    </div>
                    <div class="input-container">
                      <img src="/assets/loginIcon/mail.png" class="input-icon" />
                      <input type="email" name="email" class="form-control" [(ngModel)]="forgotPasswordEmail"
                        #email="ngModel" placeholder="Enter email address" required email />
                    </div>

                    <small class="text-danger" *ngIf="submittedForgotPasswordEmail && email.invalid">
                      Valid email is required.
                    </small>

                    <small [ngClass]="{
                       'text-success': isforgotPasswordStatus,
                        'text-danger': !isforgotPasswordStatus
                       }" *ngIf="submittedForgotPasswordEmail && forgotPasswordResMessage">
                      {{ forgotPasswordResMessage }}
                    </small>
                  </div>

              <button class="userSignINButton mt-2" type="submit" (click)="onSubmitForgotPassword()" [disabled]="loading">
  <div *ngIf="loading" class="spinner-border text-info me-2" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  {{ loading ? 'Sending...' : 'Send Email' }}
</button>
                </form>


                <label class="labels">Verify OTP</label>
                <div class="d-flex justify-content-center align-items-center mb-3">
                  <ng-otp-input [(ngModel)]="enteredOTP" name="otp" [config]="otpConfig"
                    (onInputChange)="onOTPInput($event)"></ng-otp-input>
                </div>

                <div class="verifyOTPButton"
                  *ngIf="submittedForgotPasswordEmail && loading == false" 
                  [ngStyle]="{ 'background-color': enteredOTP.length === otpConfig.length ? '#309EAE' : '#D1D1D1' }"
                  [ngClass]="{ 'disabled-button': enteredOTP.length !== otpConfig.length }"
                  (click)="enteredOTP.length === otpConfig.length ? forgotPasswordVerifyOTP() : null">
                  Confirm OTP
                </div>


              </div>





            </div>

            <div *ngIf="setForgotNewPasswordCart">
              <form [formGroup]="resetPasswordForm">
                <div class="form-group mb-3">
                  <label class="labels">New Password</label>
                  <div class="input-container">
                    <img src="/assets/loginIcon/pass.png" class="input-icon" />
                    <input [type]="singINPasswordFieldType" class="form-control" formControlName="password"
                      placeholder="Enter new password" />
                    <img *ngIf="singINPasswordFieldType === 'password'" src="/assets/loginIcon/showpass.png"
                      alt="Show Password" class="eye-icon" (click)="toggleSignINPassword()" />
                    <img *ngIf="singINPasswordFieldType === 'text'" src="/assets/loginIcon/Frame.png"
                      alt="Hide Password" class="eye-icon" (click)="toggleSignINPassword()" />
                  </div>
                  <small class="text-danger" *ngIf="  resetPasswordForm.get('password')?.invalid">
                    Password must be at least 8 characters.
                  </small>
                </div>

                <div class="form-group mb-3">
                  <label class="labels">Confirm Password</label>
                  <div class="input-container">
                    <img src="/assets/loginIcon/pass.png" class="input-icon" />
                    <input [type]="confirmPasswordFieldType" class="form-control" formControlName="confirmPassword"
                      placeholder="Confirm new password" />
                    <img *ngIf="confirmPasswordFieldType === 'password'" src="/assets/loginIcon/showpass.png"
                      alt="Show Password" class="eye-icon" (click)="toggleConfirmPassword()" />
                    <img *ngIf="confirmPasswordFieldType === 'text'" src="/assets/loginIcon/Frame.png"
                      alt="Hide Password" class="eye-icon" (click)="toggleConfirmPassword()" />
                  </div>
                  <small class="text-danger" *ngIf="resetPasswordForm.errors?.['passwordMismatch']">
                    Passwords do not match.
                  </small>
                </div>

                <small class="text-danger"
                  *ngIf="resetPasswordForm.hasError('passwordMismatch') && submitedResetPassword">
                  Your passwords do not match.
                </small>

                <div class="verifyOTPButton"
                  [ngStyle]="{ 'background-color': resetPasswordForm.valid ? '#309EAE' : '#D1D1D1' }"
                  [ngClass]="{ 'disabled-button': !resetPasswordForm.valid }"
                  (click)="resetPasswordForm.valid ? resetPassword() : null">
                  Reset Password
                </div>
              </form>
            </div>

          </div>
          <div class="CreateAccountDiv">
            <p>
              Remembered your password?<span (click)="toggleForgotPasswordCart()"
                style="color: #309EAE; font-weight: 700; cursor: pointer;"> Sign In</span>
            </p>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>



<!-- fepotej286@coasah.com -->
 <!-- https://meet.google.com/uva-xvwh-rnr?pli=1 -->